import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51d9d4bd")

_pushScopeId("data-v-51d9d4bd")
const _hoisted_1 = { class: "service-tile" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ServiceTileItem = _resolveComponent("ServiceTileItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getServices(), (item) => {
      return (_openBlock(), _createBlock(_component_ServiceTileItem, {
        class: "service-tile-item-view",
        key: item.id,
        imageUrl: item.image.top,
        title: item.title,
        onOnClick: ($event: any) => (_ctx.selectUrlItem(item.id))
      }, null, 8, ["imageUrl", "title", "onOnClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})